import { NgModule } from '@angular/core';
import { HasCapabilityDirective } from './has-capability.directive';

@NgModule({
  declarations: [HasCapabilityDirective],
  exports: [HasCapabilityDirective],
})
export class HasCapabilityModule {}
